import { useState, useEffect, useCallback, useRef } from 'react'
import { api, CLICKUP_ORDERS_LIST_ID } from '../../lib/api.js'
import { normalizeDeals, normalizeOrders } from '../../lib/journey.js'
import { MOCK_DEALS } from './mockAccounts.js'

import { createAccountFeedController, emptyAccountFeed } from './accountFeedState.js'

// Each feed is independently authorized by the backend. Order owners and name
// groups are never treated as canonical account assignment.
export const SOURCES = [
  {
    key: 'clickup-orders',
    label: 'ClickUp · orders',
    path: '/api/clickup/accounts',
    detail: `ClickUp list ${CLICKUP_ORDERS_LIST_ID}`,
    call: (opts) => api.clickupOrders(opts),
    normalize: normalizeOrders,
  },
  {
    key: 'clickup-tasks',
    label: 'ClickUp · tasks',
    path: '/api/clickup/tasks',
    detail: `ClickUp list ${CLICKUP_ORDERS_LIST_ID}`,
    call: (opts) => api.clickupTasks(opts),
    normalize: normalizeOrders,
  },
  {
    key: 'hubspot-deals',
    label: 'HubSpot · deals',
    path: '/api/hubspot/deals',
    detail: 'Bounded HubSpot deal mirror, independently account-scoped',
    call: (opts) => api.deals(opts),
    normalize: normalizeDeals,
  },
]

function isDemo() {
  if (typeof window === 'undefined') return false
  return new URLSearchParams(window.location.search).get('demo') === '1'
}

export function useAccounts() {
  const demo = isDemo()
  const [state, setState] = useState(emptyAccountFeed)
  const controller = useRef(null)
  useEffect(() => {
    if (demo) {
      setState({ ...emptyAccountFeed(), data: normalizeDeals(MOCK_DEALS), source: {key: 'demo', label: 'Demo data'}, status: 'done', coverage: {fullOrderBook: false} })
      return
    }
    const active = createAccountFeedController({ sources: SOURCES, onChange: setState })
    controller.current = active
    active.load()
    return () => { active.dispose(); if (controller.current === active) controller.current = null }
  }, [demo])
  const reload = useCallback(() => controller.current?.load(), [])
  return { ...state, reload, demo }
}
